import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import { navigate } from 'gatsby';
import { SystemStatusContext } from '../../../../../../providers/SystemStatusProvider';
import { controlledFeatures } from '../../../../../../utils/featureControl';

const ViewDocumentButton = ({ document, handleView }) => {
  const { maintenance } = useContext(SystemStatusContext);

  if (document?.isProtected && !controlledFeatures.login) {
    return null;
  }

  if (document?.isProtected && !sessionStorage.getItem('accessToken')) {
    return (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() =>
          navigate('/bejelentkezes', { state: { navigateBack: true } })
        }
        disabled={maintenance}
      >
        Bejelentkezés
      </Button>
    );
  }

  return (
    <Button
      color="primary"
      variant="outlined"
      size="small"
      onClick={() => handleView(document)}
    >
      Megtekintés
    </Button>
  );
};

export default ViewDocumentButton;
